import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useI18n } from "@/i18n";

export default function ThankYou() {
  const { t } = useI18n();
  return (
    <section className="min-h-screen flex items-center justify-center bg-[#F5F3EF] py-20">
      <div className="max-w-lg mx-auto text-center px-6" data-testid="thank-you-page">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#0F2447] text-white mb-6">
          <CheckCircle2 size={32} />
        </div>
        <h1 className="font-serif text-3xl md:text-4xl text-[#0F2447]">{t("thank_you.title")}</h1>
        <p className="mt-4 text-base text-[#3d4757] leading-relaxed">{t("thank_you.body")}</p>
        <p className="mt-2 text-sm text-[#5a6474]">{t("thank_you.note")}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-[#B85D3D] hover:bg-[#9c4a2f] text-white px-7 py-3.5 text-sm uppercase tracking-widest rounded"
          data-testid="thank-you-back-home"
        >
          {t("thank_you.back_home")}
        </Link>
      </div>
    </section>
  );
}
